import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialogActions from '@mui/material/DialogActions';
import DescriptionIcon from '@mui/icons-material/Description';
import { useTheme } from '@mui/material/styles';

import Button from '../../shared/Button';
import Input from '../../shared/Input';

import { getFile } from '../../../util/api';

import { urls } from '../../../constants';

const DialogActions = (props) => (
  <MuiDialogActions
    {...props}
    sx={(theme) => ({ borderTop: `1px solid ${theme.palette.divider}` })}
  />
);

const CaseExportModal = (props) => {
  const {
    open,
    onClose,
    caseId,
    onSkipClick
  } = props;

  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const theme = useTheme();

  const onPhoneChange = (e) => {
    const re = /^[\+\d]?(?:[\d-.\s()]*)$/;

    if (e.target.value === '' || re.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const onSubmit = async () => {
    setLoading(true);

    try {
      await getFile(urls.exportCase, { caseId, address, phoneNumber: phone }, caseId);
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          width: 450,
          backgroundColor: 'var(--color-surface-elevated)',
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ mt: 1 }}>
        <div className="d-flex">
          <DescriptionIcon color="primary" />
          <span className="font-bold m-l-md">Referral Document</span>
        </div>
      </DialogTitle>

      <DialogContent sx={{ mb: 2 }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontWeight: 'bold', pt: 1, color: 'inherit' }}
        >
          Would you like to create a referral document for this case?
        </DialogContentText>

        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontWeight: 'bold', pt: 1, color: 'inherit' }}
        >
          If yes, please enter patient details below & click to Save a copy.
        </DialogContentText>

        <div className="m-t-lg" style={{ width: '100%' }}>
          <div className="field-container">
            <div className="secondary uppercase font-size-sm">Patient address</div>
            <div className="field-content d-flex">
              <Input
                id="address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="d-flex m-t-lg w-100 space-between align-end">
          <div className="field-container">
            <div className="secondary uppercase font-size-sm">Patient phone number</div>
            <div className="field-content d-flex">
              <Input
                id="phone"
                type="text"
                value={phone}
                onChange={onPhoneChange}
              />
            </div>
          </div>

          <Button
            type="submit"
            text="Save Referral"
            onClick={onSubmit}
            loading={loading}
            disabled={loading || !address || !phone}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <div className="d-flex flex-1 p-l-lg p-r-lg p-t-md p-b-md">
          <div
            className="flex-1 p-t-md p-b-md secondary pointer font-bold"
            onClick={onClose}
          >
            Cancel
          </div>

          <div
            className="flex-1 p-t-md p-b-md primary pointer font-bold"
            style={{ textAlign: 'right' }}
            onClick={() => onSkipClick(caseId)}
          >
            Proceed to Upload Scans
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CaseExportModal;
